import { useOpQuery } from './useOpQuery';

export const useHasPackages = (orgId: number, packageNames: string[]) => {
  const { data: packagePlans } = useOpQuery({
    apiEndpointName: 'listOrgPackagePlansSelected',
    parameters: [orgId],
    select: (heliumResponse) => heliumResponse?.json?.data,
  });

  return (packagePlans || []).some((plan) =>
    packageNames.includes(plan?.packagePlan?.package?.name || ''),
  );
};
